module.exports = __webpack_public_path__ + "static/media/G-sharp-7ths.baa5f218.png";